var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4375 10.8125C1.09375 10.8125 0.799583 10.6902 0.555 10.4456C0.310417 10.201 0.187917 9.90667 0.1875 9.5625V2.0625C0.1875 1.71875 0.31 1.42458 0.555 1.18C0.8 0.935417 1.09417 0.812917 1.4375 0.8125H11.4375C11.7812 0.8125 12.0756 0.935 12.3206 1.18C12.5656 1.425 12.6879 1.71917 12.6875 2.0625V9.5625C12.6875 9.90625 12.5652 10.2006 12.3206 10.4456C12.076 10.6906 11.7817 10.8129 11.4375 10.8125H1.4375ZM6.4375 6.4375L1.4375 3.3125V9.5625H11.4375V3.3125L6.4375 6.4375ZM6.4375 5.1875L11.4375 2.0625H1.4375L6.4375 5.1875ZM1.4375 3.3125V2.0625V9.5625V3.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.7afb5a0eb213dadb734a239ec65505f0.svg";
export { ForwardRef as ReactComponent };